/* SolisRestore CRO 2026-10-19: lead clicks, site-check routing, chat links, click-to-load reviews. */
(() => {
  function publishLead(el) {
    const payload = {
      event: 'solis_lead_click',
      lead_type: el.dataset.srLead || '',
      product: el.dataset.productTitle || document.querySelector('.product-information h1')?.textContent.trim() || '',
      section: el.closest('[data-sr-track-section]')?.dataset.srTrackSection || '',
      path: window.location.pathname,
      timestamp: new Date().toISOString(),
    };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    try {
      window.Shopify?.analytics?.publish?.('solis_lead_click', payload);
    } catch (_error) {
      // Analytics must never interrupt shopping.
    }
  }

  function bookingUrl() {
    return document.getElementById('solis-specialist')?.dataset.srBookingUrl || '';
  }

  function applyBookingLinks() {
    const url = bookingUrl();
    if (!url) return;
    document.querySelectorAll('[data-sr-site-check]').forEach((link) => {
      link.href = url;
      link.target = '_blank';
      link.rel = 'noopener';
    });
  }

  // No booking link yet: open the product's own question form with the product named.
  function openQuestionForm(el) {
    const form = document.querySelector('#fit-check form, #product-questions form');
    if (!form) return false;
    const body = form.querySelector('textarea[name="contact[body]"]');
    const title = el.dataset.productTitle || '';
    if (body && !body.value.trim()) {
      body.value = `I'd like a 15-min fit call${title ? ` about the ${title}` : ''} (space, delivery path and power). `;
    }
    form.scrollIntoView({ behavior: 'smooth', block: 'center' });
    (form.querySelector('input[type="email"]') || body)?.focus({ preventScroll: true });
    return true;
  }

  document.addEventListener('click', (event) => {
    const lead = event.target.closest('[data-sr-lead]');
    if (lead) {
      publishLead(lead);
      if (lead.hasAttribute('data-sr-site-check') && !bookingUrl() && openQuestionForm(lead)) {
        event.preventDefault();
      }
      if (lead.hasAttribute('data-sr-cro-chat') && window.solisOpenChat && window.solisOpenChat()) {
        event.preventDefault();
      }
    }
    const more = event.target.closest('[data-sr-reviews-more]');
    if (more) {
      const section = more.closest('.sr-reviews');
      const open = section.classList.toggle('is-expanded');
      more.setAttribute('aria-expanded', String(open));
      if (!more.dataset.label) more.dataset.label = more.textContent;
      more.textContent = open ? 'Show fewer reviews' : more.dataset.label;
    }
    const play = event.target.closest('[data-sr-yt]');
    if (play) {
      const frame = document.createElement('iframe');
      frame.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(play.dataset.srYt)}?autoplay=1&rel=0`;
      frame.title = play.getAttribute('aria-label') || 'Independent review';
      frame.allow = 'accelerometer; autoplay; encrypted-media; picture-in-picture';
      frame.allowFullscreen = true;
      frame.className = 'sr-reviews__frame';
      play.replaceWith(frame);
    }
  });

  // Review thumbnails load only when the reviews section approaches the viewport.
  function lazyThumbs() {
    const thumbs = document.querySelectorAll('img[data-sr-yt-thumb]');
    if (!thumbs.length) return;
    const load = (img) => {
      const id = img.closest('[data-sr-yt]')?.dataset.srYt;
      if (id) img.src = `https://i.ytimg.com/vi/${encodeURIComponent(id)}/hqdefault.jpg`;
    };
    if (!('IntersectionObserver' in window)) return thumbs.forEach(load);
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        load(entry.target);
        io.unobserve(entry.target);
      });
    }, { rootMargin: '400px' });
    thumbs.forEach((img) => io.observe(img));
  }

  // P2: on the default sort of a collection, list accessories after the main products (rooms first on
  // /collections/saunas). DOM order, not CSS order, so keyboard and screen-reader order match. An
  // explicit sort chosen by the shopper is left alone; accessories stay under their scope-rail chip.
  function accessoriesLast() {
    if (new URLSearchParams(window.location.search).get('sort_by')) return;
    const grid = document.querySelector('ul[ref="grid"]');
    if (!grid) return;
    const items = [...grid.querySelectorAll(':scope > li[data-type]')];
    const acc = items.filter((li) => /accessor/.test(li.dataset.type));
    if (!acc.length || acc.length === items.length) return;
    acc.forEach((li) => grid.appendChild(li));
  }

  function init() {
    accessoriesLast();
    applyBookingLinks();
    lazyThumbs();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* 2026-10-21: on phones, hide the Shopify Inbox bubble while a marked CTA area ([data-sr-chat-yield]) is on
   screen, so it never sits on top of a primary button. It returns as soon as that area scrolls away, and never
   hides while chat is open or after a theme link opened it (data-sr-chat-used). */
(function () {
  var areas = document.querySelectorAll('[data-sr-chat-yield]');
  if (!areas.length || !('IntersectionObserver' in window)) return;
  var visible = new Map();
  function apply() {
    var chat = document.querySelector('shopify-chat');
    if (!chat) return;
    var on = false;
    visible.forEach(function (v) { if (v) on = true; });
    chat.classList.toggle('sr-chat-yield', window.innerWidth < 750 && on && !chat.hasAttribute('open') && !chat.dataset.srChatUsed);
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { visible.set(e.target, e.isIntersecting); });
    apply();
  });
  areas.forEach(function (el) { visible.set(el, false); io.observe(el); });
  setTimeout(apply, 1500);
})();
